'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n  padding: ', ';\n  margin: ', ';\n  fill: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n  padding: ', ';\n  margin: ', ';\n  fill: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var SVGContainer = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.width || '10px';
}, function (props) {
  return props.height || '10px';
}, function (props) {
  return props.padding || '0';
}, function (props) {
  return props.margin || 'auto';
}, function (props) {
  return props.theme[props.color] || props.theme.color_white;
});
var Loading = function (_Component) {
  _inherits(Loading, _Component);
  function Loading() {
    _classCallCheck(this, Loading);
    return _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
  }
  _createClass(Loading, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SVGContainer, Object.assign({}, this.props, {
        viewBox: '0 0 100 100'
      }), _react2.default.createElement('circle', {
        cx: '84',
        cy: '50',
        r: '0'
      }, _react2.default.createElement('animate', {
        attributeName: 'r',
        values: '10;0;0;0;0',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '0s'
      }), _react2.default.createElement('animate', {
        attributeName: 'cx',
        values: '84;84;84;84;84',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '0s'
      })), _react2.default.createElement('circle', {
        cx: '16',
        cy: '50',
        r: '9.96987'
      }, _react2.default.createElement('animate', {
        attributeName: 'r',
        values: '0;10;10;10;0',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '-0.5s'
      }), _react2.default.createElement('animate', {
        attributeName: 'cx',
        values: '16;16;50;84;84',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '-0.5s'
      })), _react2.default.createElement('circle', {
        cx: '84',
        cy: '50',
        r: '0.0301342'
      }, _react2.default.createElement('animate', {
        attributeName: 'r',
        values: '0;10;10;10;0',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '-0.25s'
      }), _react2.default.createElement('animate', {
        attributeName: 'cx',
        values: '16;16;50;84;84',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '-0.25s'
      })), _react2.default.createElement('circle', {
        cx: '83.8975',
        cy: '50',
        r: '10'
      }, _react2.default.createElement('animate', {
        attributeName: 'r',
        values: '0;10;10;10;0',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '0s'
      }), _react2.default.createElement('animate', {
        attributeName: 'cx',
        values: '16;16;50;84;84',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '0s'
      })), _react2.default.createElement('circle', {
        cx: '49.8975',
        cy: '50',
        r: '10'
      }, _react2.default.createElement('animate', {
        attributeName: 'r',
        values: '0;0;10;10;10',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '0s'
      }), _react2.default.createElement('animate', {
        attributeName: 'cx',
        values: '16;16;16;50;84',
        keyTimes: '0;0.25;0.5;0.75;1',
        keySplines: '0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1',
        calcMode: 'spline',
        dur: '1s',
        repeatCount: 'indefinite',
        begin: '0s'
      })));
    }
  }]);
  return Loading;
}(_react.Component);
exports.default = Loading;